/** True when the value has characters other than whitespace. */
export const hasText = (value: string | null | undefined): value is string =>
  value != null && value.trim() !== ""
